import React, { useEffect } from "react";
import Script from "next/script";
import rfStore from "@/utils/rfStore";
import { ptenginLogin } from "@/utils/logo2Ptengin";
import LongPressContainer from "@/containers/common/LongPressContainer";
import { useRouter } from "next/router";
import { saveShareParams } from "@/utils/shortLinkTransfer";
interface LayoutProps {
	children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
	const router = useRouter();
	useEffect(() => {
		saveShareParams(
			router.query.mediaSource as string,
			router.query.campaign as string,
			router.query.channel as string,
		);
	}, []);

	return (
		<>
			<Script
				src="/third-party/sensorsdata.min.js"
				onLoad={() => {
					const sensors = window.sensorsDataAnalytic201505;
					sensors.init({
						server_url: process.env.NEXT_PUBLIC_SENSORS_SERVER_URL,
						heatmap: { scroll_notice_map: "not_collect" },
						is_track_single_page: true,
						use_client_time: true,
						send_type: "beacon",
						// show_log: process.env.NODE_ENV === "development" ? true : false,
						show_log: false,
						app_js_bridge: rfStore.getRFState()?.model ? true : false, // APP H5 打通
					});

					sensors.quick("autoTrack"); //用于采集 $pageview 事件。
					sensors.use("PageLeave");
					sensors.use("PageLoad");
				}}
			></Script>

			<Script
				src={process.env.NEXT_PUBLIC_PT_ENGINE_SDK}
				onError={(e) => {}}
				onLoad={() => {
					ptenginLogin();
				}}
			></Script>
			<LongPressContainer>{children}</LongPressContainer>
		</>
	);
}
